import { jsxs, jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import 'react';
import SystemIcon from '../../DataDisplays/SystemIcon/SystemIcon.js';
import Typography from '../../Base/Typography/Typography.js';
import Box from '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * 텍스트 버튼 컴포넌트
 *
 * @description
 * 텍스트로만 구성된 버튼 컴포넌트입니다. 선택적으로 앞이나 뒤에 아이콘을 배치할 수 있습니다.
 * 텍스트의 크기는 기본 크기와 작은 크기 중 선택할 수 있습니다.
 *
 * @param {object} props
 * @param {string} props.text - 버튼에 표시될 텍스트
 * @param {boolean} [props.isTextSmall=false] - 텍스트 크기를 작게 설정 (기본값: false)
 * @param {string} [props.leadingIcon] - 텍스트 앞에 표시될 SystemIcon의 이름
 * @param {string} [props.trailingIcon] - 텍스트 뒤에 표시될 SystemIcon의 이름
 *
 * @example
 * // 기본 텍스트 버튼
 * <TextButton text="버튼 텍스트" />
 *
 * // 작은 텍스트와 앞뒤 아이콘이 있는 버튼
 * <TextButton
 *   text="버튼 텍스트"
 *   isTextSmall={true}
 *   leadingIcon="search"
 *   trailingIcon="arrow-right"
 * />
 */ const TextButton = (_param)=>{
    var { text, isTextSmall = false, leadingIcon, trailingIcon } = _param, rest = _object_without_properties(_param, [
        "text",
        "isTextSmall",
        "leadingIcon",
        "trailingIcon"
    ]);
    return /*#__PURE__*/ jsxs("button", _object_spread_props(_object_spread({
        "data-testid": "design-system-text-button--container",
        className: twMerge('flex min-h-6 w-fit items-center justify-center', isTextSmall ? 'gap-x-0.5' : 'gap-x-1')
    }, rest), {
        children: [
            leadingIcon && /*#__PURE__*/ jsx(Box, {
                "data-testid": "design-system-text-button--icon--left",
                className: "w-fit",
                children: /*#__PURE__*/ jsx(SystemIcon, {
                    name: leadingIcon,
                    className: "text-primary-500"
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                "data-testid": "design-system-text-button--text",
                className: "w-fit",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: isTextSmall ? 'body2' : 'body1',
                    className: "align-baseline font-medium text-primary-500",
                    children: text
                })
            }),
            trailingIcon && /*#__PURE__*/ jsx(Box, {
                "data-testid": "design-system-text-button--icon--right",
                className: "w-fit",
                children: /*#__PURE__*/ jsx(SystemIcon, {
                    name: trailingIcon,
                    className: "text-primary-500"
                })
            })
        ]
    }));
};

export { TextButton as default };
